module.exports = __webpack_public_path__ + "static/media/400393_02.0df1dc6e.png";